import * as expect from "ts-expect";

expect.expectType<number>(123);
